import React from 'react';
import PropTypes from 'prop-types';
import Link from 'next/link';
import Image from 'next/image';
import { flagsmith } from '@common/Lib/Flagsmith';
import { getImageUrlWithSize } from '@common/Utility/common-utils';
import AddToCart from 'Epharmacy/Cart/AddToCart';
import useScrollHandler from '@common/Context/useScrollHandler';
import { FLAGSMITH_KEYS, ONLINE_PHARMACY_ROUTE } from '@common/Utility/constants';
import { useNavigationURL } from '@common/Utility/generateNavigationURL';

const ScrolledCartDetails = ({
  detailsData,
  brandData,
  skuForAddToCart,
  removeDecimalPoints,
  customAttribute,
  scrollToView,
  checkIfInCart,
  pdpUpSellingFlag,
  setErrors,
  screenName,
  pageId,
  pageType,
  referrerpage,
  sectionName
  
}) => {
  const scrollY = useScrollHandler();
  const generateURL = useNavigationURL();
  const web_feature_flaging = flagsmith.getValue(FLAGSMITH_KEYS.WEB_FEATURE_FLAGING, {json: true});

  if (scrollY > 440) {
    return (
      <div className="scrolledCartDetails">
        {web_feature_flaging?.isCartEnable && detailsData?.outOfStock && (
          <div className="scrolled-card-oos">
            <div className='container content'>This item is currently out of stock.</div>
          </div>
        )}
        <div className="container ">
          <div className="prodDetail">
            <div className="prodThumb">
              <Image src={getImageUrlWithSize(detailsData?.mediaGalleryEntries?.[0]?.file, 64, 64)} width="64px" height="64px" alt="" unoptimized/>
            </div>
            <div className="prodDesc">
              {brandData?.label && (
                <div className="prodLabel">
                  <Link href={generateURL(`${ONLINE_PHARMACY_ROUTE}/brand/${brandData?.value}`)}>{brandData?.label}</Link>
                </div>
              )}
              <div className="prodInfo">{detailsData?.name}</div>
            </div>
          </div>
          <div className={`cartDetail${!web_feature_flaging?.isCartEnable ? " w-auto" : ""}`}>
            <div className="priceWrapper">
              {detailsData?.specialPrice ? (
                <>
                  <div className="price">
                    <div>{detailsData?.currency}</div>&nbsp;{removeDecimalPoints(detailsData?.specialPrice)}
                    &nbsp;
                    <span>
                      <div>{detailsData?.currency}</div>&nbsp;{removeDecimalPoints(detailsData?.price)}
                    </span>
                    <br />
                  </div>
                  {detailsData?.priceBreakup && <div className="priceBreakup">{detailsData?.priceBreakup}</div>}
                </>
              ) : (
                <div className="price">
                  <div>{detailsData?.currency}</div>&nbsp;{removeDecimalPoints(detailsData?.price)}
                </div>
              )}
            </div>
            {web_feature_flaging?.isCartEnable &&
              <div className="orderWrapper">
                <AddToCart
                  size="md"
                  enableFullWidth
                  isFloat
                  isProductDetails
                  availableStock={detailsData?.availableStock}
                  sku={skuForAddToCart}
                  outOfStock={detailsData?.outOfStock}
                  productName={detailsData?.name}
                  productType=""
                  productCategory={detailsData?.categoryPath ? detailsData?.categoryPath : customAttribute?.categoryIds}
                  price={detailsData?.specialPrice ? detailsData?.specialPrice : detailsData?.price}
                  offer={detailsData?.badgeDetails?.offerBadge ? 'yes' : 'no'}
                  product={detailsData}
                  deliveryPromise={detailsData?.express === true ? 'Express' : 'Standard'}
                  brand={detailsData?.brandDetails?.brandName}
                  screenType={detailsData?.categoryPath?.[0]?.label}
                  categories={detailsData?.categoryPath}
                  deliverBy={detailsData?.deliverBy}
                  scrollToViewFBT={scrollToView}
                  checkIfInCart={checkIfInCart}
                  pdpUpSellingFlag={pdpUpSellingFlag}
                  setErrors={setErrors}
                  screenName={screenName}
                  pageId={pageId}
                  pageType={pageType}
                  referrerpage={referrerpage}
                  sectionName={sectionName}
                />
              </div>
            }
          </div>
        </div>
      </div>
    );
  }
  return '';
};

ScrolledCartDetails.propTypes = {
  detailsData: PropTypes.object,
  skuForAddToCart: PropTypes.string,
  removeDecimalPoints: PropTypes.func,
  customAttribute: PropTypes.object,
  brandData: PropTypes.object,
  scrollToView: PropTypes.func,
  checkIfInCart: PropTypes.func,
  pdpUpSellingFlag: PropTypes.string,
  setErrors: PropTypes.func,
};
ScrolledCartDetails.defaultProps = {
  detailsData: {},
  skuForAddToCart: '',
  removeDecimalPoints: () => {},
  customAttribute: {},
  brandData: {},
  scrollToView: () => {},
  checkIfInCart: () => {},
  pdpUpSellingFlag: '',
  setErrors: () => {},
};

export default ScrolledCartDetails;
